import script from "./form-affiliate.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-affiliate.vue?vue&type=script&setup=true&lang=ts"

import "./form-affiliate.vue?vue&type=style&index=0&id=7f481e34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f481e34"]])

export default __exports__